import { union_type, class_type } from "../fable_modules/fable-library.3.6.2/Reflection.js";
import { createElement } from "react";
import * as react from "react";
import { useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.1.57.0/React.fs.js";
import { singleton as singleton_1, sortBy, item, tail, head, isEmpty, ofArray } from "../fable_modules/fable-library.3.6.2/List.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.57.0/Interop.fs.js";
import { RouterModule_router, RouterModule_urlSegments } from "../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { append, empty, collect, singleton, delay, toList } from "../fable_modules/fable-library.3.6.2/Seq.js";
import { equals, comparePrimitives, createObj, randomNext } from "../fable_modules/fable-library.3.6.2/Util.js";
import { Text as Text$, Rect as Rect_1, Circle as Circle_1, Layer, Stage } from "react-konva";
import { Union } from "../fable_modules/fable-library.3.6.2/Types.js";
import { MazeElement, Connection__isValid, Connection, Maze__get_bounds } from "../Domain.fs.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library.3.6.2/Int32.js";
import { mapIndexed } from "../fable_modules/fable-library.3.6.2/Array.js";

export class Components {
    constructor() {
    }
}

export function Components$reflection() {
    return class_type("UI.Components.Components", void 0, Components);
}

export function Components_get_rand() {
    return {};
}

export function Components_HelloWorld() {
    return createElement("h1", {
        children: ["Hello World"],
    });
}

export function Components_Counter() {
    const patternInput = useFeliz_React__React_useState_Static_1505(0);
    const count = patternInput[0] | 0;
    const children = ofArray([createElement("h1", {
        children: [count],
    }), createElement("button", {
        onClick: (_arg1) => {
            patternInput[1](count + 1);
        },
        children: "Increment",
    })]);
    return createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function Components_Router() {
    const patternInput = useFeliz_React__React_useState_Static_1505(RouterModule_urlSegments(window.location.hash, 1));
    const currentUrl = patternInput[0];
    return RouterModule_router({
        onUrlChanged: patternInput[1],
        application: react.createElement(react.Fragment, {}, ...toList(delay(() => {
            let value_1, value;
            return (!isEmpty(currentUrl)) ? ((head(currentUrl) === "hello") ? (isEmpty(tail(currentUrl)) ? singleton(createElement(Components_HelloWorld, null)) : singleton((value_1 = item(randomNext(0, 3), ofArray(["Not found, y\u0027all", "sorry, couldn\u0027t find it", "Nope, try again"])), createElement("h1", {
                children: [value_1],
            })))) : ((head(currentUrl) === "counter") ? (isEmpty(tail(currentUrl)) ? singleton(createElement(Components_Counter, null)) : singleton((value_1 = item(randomNext(0, 3), ofArray(["Not found, y\u0027all", "sorry, couldn\u0027t find it", "Nope, try again"])), createElement("h1", {
                children: [value_1],
            })))) : singleton((value_1 = item(randomNext(0, 3), ofArray(["Not found, y\u0027all", "sorry, couldn\u0027t find it", "Nope, try again"])), createElement("h1", {
                children: [value_1],
            }))))) : singleton((value = (`Index: ${currentUrl}`), createElement("h1", {
                children: [value],
            })));
        }))),
    });
}

export function Konva_stage(props) {
    return Interop_reactApi.createElement(Stage, createObj(props));
}

export function Konva_layer(props) {
    return Interop_reactApi.createElement(Layer, createObj(props));
}

export function Konva_circle(props) {
    return Interop_reactApi.createElement(Circle_1, createObj(props));
}

export function Konva_rect(props) {
    return Interop_reactApi.createElement(Rect_1, createObj(props));
}

export function Konva_text(props) {
    return Interop_reactApi.createElement(Text$, createObj(props));
}

export class Shape {
    constructor() {
    }
}

export function Shape$reflection() {
    return class_type("UI.Components.Shape", void 0, Shape);
}

export function Shape_get_draggable() {
    return ["draggable", true];
}

export class Circle {
    constructor() {
    }
}

export function Circle$reflection() {
    return class_type("UI.Components.Circle", void 0, Circle, Shape$reflection());
}

export class Rect {
    constructor() {
    }
}

export function Rect$reflection() {
    return class_type("UI.Components.Rect", void 0, Rect, Shape$reflection());
}

export class Maze_MouseMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["CarvingSpace", "BuildingWalls", "Inactive"];
    }
}

export function Maze_MouseMode$reflection() {
    return union_type("UI.Components.Maze.MouseMode", [], Maze_MouseMode, () => [[], [], []]);
}

export const Maze_gridSize = 20;

export function Maze_nearestIntersection(maze, xPixel, yPixel) {
    const yBase = (maze.grid[0].length * Maze_gridSize) | 0;
    const maybe = (tupledArg) => {
        const patternInput = [~(~(tupledArg[0] / Maze_gridSize)), ~(~((yBase - tupledArg[1]) / Maze_gridSize))];
        const candidate = new Connection(0, patternInput[0], patternInput[1], Maze__get_bounds(maze));
        if (Connection__isValid(candidate)) {
            return candidate;
        }
        else {
            return void 0;
        }
    };
    const matchValue = maybe([xPixel, yPixel]);
    if (matchValue == null) {
        return head(sortBy((tuple_2) => tuple_2[0], toList(delay(() => {
            const square = (x_2) => (x_2 * x_2);
            const patternInput_1 = [((~(~(xPixel / Maze_gridSize))) * Maze_gridSize) + (~(~(Maze_gridSize / 2))), ((~(~(yPixel / Maze_gridSize))) * Maze_gridSize) + (~(~(Maze_gridSize / 2)))];
            return collect((xMod) => collect((yMod) => {
                const gridCenter = [patternInput_1[0] + xMod, patternInput_1[1] + yMod];
                const matchValue_1 = maybe(gridCenter);
                if (matchValue_1 == null) {
                    return empty();
                }
                else {
                    const candidate_1 = matchValue_1;
                    return singleton([Math.sqrt(square(gridCenter[0] - xPixel) + square(gridCenter[1] - yPixel)), candidate_1]);
                }
            }, [op_UnaryNegation_Int32(Maze_gridSize), 0, Maze_gridSize]), [op_UnaryNegation_Int32(Maze_gridSize), 0, Maze_gridSize]);
        })), {
            Compare: (x_3, y_1) => comparePrimitives(x_3, y_1),
        }))[1];
    }
    else {
        return matchValue;
    }
}

export function Maze_render(maze, mode, modeChange) {
    const window$ = window;
    const isRightClick = (e) => (e.evt.button === 2);
    const h = window$.innerHeight - 100;
    const yBase = ((maze.grid[0].length - 1) * 20) | 0;
    return Konva_stage(toList(delay(() => append(singleton(["width", window$.innerWidth - 100]), delay(() => append(singleton(["height", h]), delay(() => append(singleton(["children", singleton_1(Konva_layer(singleton_1(["children", toList(delay(() => {
        const zip = (a, b) => [a, b];
        return collect((matchValue) => {
            const x = matchValue[0] | 0;
            return collect((matchValue_1) => {
                const y = matchValue_1[0] | 0;
                return equals(matchValue_1[1], new MazeElement(1)) ? singleton(Konva_rect(toList(delay(() => append(singleton(["x", x * 20]), delay(() => append(singleton(["y", yBase - (y * 20)]), delay(() => append(singleton(["height", 20]), delay(() => append(singleton(["width", 20]), delay(() => append(singleton(["fill", "grey"]), delay(() => append((equals(mode, new Maze_MouseMode(0)) && Connection__isValid(new Connection(0, x, y, Maze__get_bounds(maze)))) ? singleton(["opacity", 0.8]) : empty(), delay(() => append(singleton(["key", [x, y]]), delay(() => {
                    switch (mode.tag) {
                        case 0: {
                            return singleton(["onMouseOver", (e_2) => {
                                modeChange([new Maze_MouseMode(0), new Connection(0, x, y, Maze__get_bounds(maze))]);
                            }]);
                        }
                        case 1: {
                            return empty();
                        }
                        default: {
                            return singleton(["onMouseDown", (e_1) => {
                                modeChange([isRightClick(e_1) ? (new Maze_MouseMode(1)) : (new Maze_MouseMode(0)), new Connection(0, x, y, Maze__get_bounds(maze))]);
                            }]);
                        }
                    }
                })))))))))))))))))) : ((equals(mode, new Maze_MouseMode(1)) && Connection__isValid(new Connection(0, x, y, Maze__get_bounds(maze)))) ? singleton(Konva_rect(ofArray([["x", x * 20], ["y", yBase - (y * 20)], ["height", 20], ["width", 20], ["fill", "grey"], ["key", [x, y]], ["opacity", 0.3]]))) : empty());
            }, mapIndexed(zip, matchValue[1]));
        }, mapIndexed(zip, maze.grid));
    }))])))]), delay(() => append(singleton(["onMouseUp", (_arg1) => {
        modeChange([new Maze_MouseMode(2), void 0]);
    }]), delay(() => append(singleton(["onMouseEnter", (_arg2) => {
        modeChange([new Maze_MouseMode(2), void 0]);
    }]), delay(() => append(singleton(["onMouseDown", (e_3) => {
        const pos = (e_3.target.getStage()).getPointerPosition();
        if ((pos.x < (maze.grid.length * 20)) && (pos.y < (maze.grid[0].length * 20))) {
            const pos_1 = Maze_nearestIntersection(maze, pos.x, pos.y);
            if (isRightClick(e_3)) {
                modeChange([new Maze_MouseMode(1), pos_1]);
            }
            else {
                modeChange([new Maze_MouseMode(0), pos_1]);
            }
        }
    }]), delay(() => append(singleton(["onContextMenu", (e_4) => (e_4.evt.preventDefault())]), delay(() => (equals(mode, new Maze_MouseMode(1)) ? singleton(["onMouseOver", (e_5) => {
        const pos_2 = (e_5.target.getStage()).getPointerPosition();
        if ((pos_2.x < (maze.grid.length * 20)) && (pos_2.y < (maze.grid[0].length * 20))) {
            modeChange([new Maze_MouseMode(1), Maze_nearestIntersection(maze, pos_2.x, pos_2.y)]);
        }
    }]) : empty()))))))))))))))))));
}

